module.exports = __webpack_public_path__ + "static/img/01038B_6_C_20230531_LC.aea429b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/01038B_6_C_20230531_LC.png
// module id = wDXt
// module chunks = 0